<template>
  <div ref="newsCont">
    <div class="news">
      <div class="newsDetail">
        <h3>{{item.listTitle}}</h3>
        <div class="desc">
          <span class="mar30_r">{{item.addTime1}}</span>
          <span class="mar30_r">来源：{{item.source}}</span>
          <span>作者：{{item.author}}</span>
        </div>
        <!-- <van-image
  lazy-load
  :src="item.imgs" v-if="item.imgs"
/> -->
        <div class="cont f28 line_h50 mar10_tb" v-html="item.content">
         </div>
        <!-- <div class="shareBotton text-center border_t">
          <van-button round plain hairline class="w200 height80" type="default" size="small">
            <i class="iconfont iconshare gray3"></i>
            <em class="f30 mar10_l">分享</em>
          </van-button>
        </div> -->
      </div>
      <div id="d_footer" class="d_footer">
        <h3 id="fixedDom">欢迎垂询</h3>
        <p class="desc">欢迎关注官方微信“数说产业互联网”，阅读更多精彩文章。也可以扫描下方二维码添加关注。数说产业互联网将为您提供更多解决方案</p>
        <ul class="cont clear">
          <li>
            <div class="mask">
              <div class="desc">
                <p>乡村振兴数字化解决方案</p>
                <div class="link" @click="routerLink('/solution/0')">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_01.png" alt />
          </li>
          <li>
            <div class="mask">
              <div class="desc">
                <p>农业单品行业大数据解决方案</p>
                <div class="link" @click="routerLink('/solution/1')">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_02.png" alt />
          </li>
          <li>
            <div class="mask">
              <div class="desc">
                <p>农业链主企业数字 化解决方案</p>
                <div class="link" @click="routerLink('/solution/2')">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_03.png" alt />
          </li>
          <li>
            <div class="mask">
              <div class="desc">
                <p>现代农业产业园数 字化解决方案</p>
                <div class="link" @click="routerLink('/solution/3')">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_04.png" alt />
          </li>
          <li>
            <div class="mask">
              <div class="desc">
                <p>农产品区域公用品牌数字化解决方案</p>
                <div class="link" @click="routerLink('/solution/4')">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_05.png" alt />
          </li>
          <li>
            <div class="mask">
              <div class="desc">
                <p>农产品批发市场/交易中心数字化解决方案</p>
                <div class="link" @click="routerLink('/solution/5')">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_06.png" alt />
          </li>
        </ul>
      </div>
      <bottom-dialog :isFixed="isF"></bottom-dialog>
    </div>

  </div>
</template>

<script>
import bottomDialog from "./components/bottomDialog.vue";

export default {
  components: {
    bottomDialog: bottomDialog,
  },
  data() {
    return {
      item: {},
      headerH: 0,
      footerH: 0,
      fixedH: 0,
      isF: true,
      showImgs: false,
      index: 1,
      scrollHandle: null,
    };
  },
  mounted() {
    this.loadData(this.$route.params.id)
    this.loadStatic();
    this.scrollHandle = () => {
      this.isFixed();
    };
    document.addEventListener("scroll", this.scrollHandle, false);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollHandle, false);
  },
  methods: {
    loadStatic() {
      this.headerH = document.getElementById("mob_header").offsetHeight;
      this.fixedH = document.getElementById("fixedDom").offsetHeight;
      this.footerH = document.getElementById("d_footer").offsetHeight;
    },
    isFixed() {
      // 获取视口高度
      let viewH =
        document.documentElement.clientHeight || document.body.clientHeight;
      let domH = this.$refs["newsCont"].clientHeight;
      let scrollY = window.scrollY;
      let isF =
        scrollY + viewH <= domH + this.headerH - this.footerH + this.fixedH;
      this.isF = isF;
    },
    routerLink(url) {
      this.$router.push(url);
    },
    loadData(id) {
      if(id) {
      this.$store
        .dispatch("api/selContentDetailByAdId", {
          id: id,
        })
        .then(response => {
          if(response ) {
            this.item = response
          }
        })
        .catch(() => {
        });
    }
    }
  },
};
</script>

<style lang="scss">
@import "~@/assets/mob/css/news.scss";
</style>